import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/contents/:content_id",
    name: "Contents",
    component: () =>
      import(/* webpackChunkName: "contents" */ "../views/Page/ContentsView.vue"),
    props: true,
    meta: {
      IsAuth: true
    }
  },
  {
    path: "/categorys/:catid",
    name: "Categorys",
    component: () =>
      import(/* webpackChunkName: "categorys" */ "../views/Page/CategorysView.vue"),
    props: true,
  },
  {
    path: "/searchs/:search_id",
    name: "Searchs",
    component: () =>
      import(/* webpackChunkName: "searchs" */ "../views/Page/SearchsView.vue"),
    props: true,
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/User/LoginView.vue"),
  },{
    path: "/Profile",
    name: "Profile",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/User/profileView.vue"),
  },
  {
    path: "/subscribes",
    name: "Subscribes",
    component: () =>
      import(
        /* webpackChunkName: "subscribes" */ "../views/User/SubscribesView.vue"
      ),
  },
  {
    path: "/unsubscribes",
    name: "Unsubscribes",
    component: () => import(/* webpackChunkName: "unsubscribes" */ "../views/User/UnsubscribesView.vue"),
    meta: {
      IsAuth: true
    }
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFounds",
    component: () =>
      import(/* webpackChunkName: "notFounds" */ "../views/Page/NotFoundsView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach((to, from, next ) => {
  const { $cookie } = router.app.config.globalProperties
   if(to.meta.IsAuth) {
    if($cookie.isCookieAvailable("msisdn") && $cookie.isCookieAvailable("status")) {
      next();
    } else {
      next();
      // next('/Subscribes')
      // next(window.open("https://dsplp.sd.zain.com/af-lp/?p=4372482367", "_self"));
    }
   } else {
     next();
   }
})

export default router;
